export const roleRank = { viewer: 0, contributor: 1, reviewer: 2, admin: 3 }

export function canWrite(role) {
  return (roleRank[role] ?? -1) >= roleRank.contributor
}

export function formatDate(value) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}

export function formatRefreshTime(value) {
  if (!value) return 'Not yet refreshed'
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(value)
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString('en-GB')
}

export function makeId(prefix) {
  return `${prefix}-${crypto.randomUUID().slice(0, 8).toUpperCase()}`
}

export function getInitials(name, email) {
  const source = (name || email || 'Botanical user').trim()
  const parts = source.split(/\s+|@/).filter(Boolean)
  return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase()
}
